import { render } from "./QuickAddProductComponent.vue?vue&type=template&id=58ec792e"
import script from "./QuickAddProductComponent.vue?vue&type=script&lang=js"
export * from "./QuickAddProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/quick-add-product/QuickAddProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58ec792e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58ec792e', __exports__)) {
    api.reload('58ec792e', __exports__)
  }
  
  module.hot.accept("./QuickAddProductComponent.vue?vue&type=template&id=58ec792e", () => {
    api.rerender('58ec792e', render)
  })

}


export default __exports__